import { AcceptanceAction } from '@faire/web-api--source/com/faire/terms_of_service/AcceptanceAction';
import { ITermsOfServiceArticle } from '@faire/web-api--source/com/faire/terms_of_service/ITermsOfServiceArticle';
import { ISO3166Alpha3 } from '@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3';

export namespace ITermsOfServiceAcceptance {
  /**
   * Return an instance of ITermsOfServiceAcceptance with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ITermsOfServiceAcceptance>
  ): ITermsOfServiceAcceptance =>
    ({
      ...(partial ?? {}),
    }) as ITermsOfServiceAcceptance;
}

export interface ITermsOfServiceAcceptance {
  article: ITermsOfServiceArticle | undefined;
  user_token: string | undefined;
  retailer_token: string | undefined;
  brand_token: string | undefined;
  other_identifier: string | undefined;
  accepted_at: number | undefined;
  ip_address: string | undefined;
  user_agent: string | undefined;
  action: keyof typeof AcceptanceAction | undefined;
  override_country: keyof typeof ISO3166Alpha3 | undefined;
}
